import useRouter from '../../../hooks/useRouter'
import { useMemo, useState } from 'react'
import { TABS_OPTIONS, TABS_OPTIONS_KEY } from './constants'
import RadioGroup from '../../../components/RadioGroup/RadioGroup'
import { useHSDetailsContext } from '../HealthSystems/FullView/Providers/HSContextProvider'
import { GeneralDetails } from '../HealthSystems/FullView/General/GeneralDetails'
import { HospitalsTable } from '../HealthSystems/FullView/HospitalsTable/HospitalsTable'
import { Users } from '../HealthSystems/FullView/Users/Users'
import { BankingSetupContainer } from '../BankingSetupCommunity/BankingSetupContainer'
import { HSDetailsBankAccountsContainer } from '../HealthSystems/FullView/HSDetailsBankAccountsContainer'

export const MyOrganizationHealthSystem = () => {
  const { query, push } = useRouter()
  const {
    state: {
      canViewHospitals,
      canViewUsers,
      canViewBankingSetup,
      canViewBankAccounts,
      canEditHS,
      details,
      businessAccountDetails,
      outsideCommunityMode
    },
    actions: { refreshHSDetails }
  } = useHSDetailsContext()
  const [activeSubTab, setActiveSubTab] = useState(
    query?.type || TABS_OPTIONS[0].value
  )
  const handleTabs = (e) => {
    setActiveSubTab(e)
    push(e)
  }

  const availableTabs = useMemo(() => {
    return TABS_OPTIONS.filter(({ value }) => {
      switch (value) {
        case TABS_OPTIONS_KEY.hospitals:
          return canViewHospitals
        case TABS_OPTIONS_KEY.users:
          return canViewUsers
        case TABS_OPTIONS_KEY.banking_setup:
          return canViewBankingSetup
        case TABS_OPTIONS_KEY.bank_accounts:
          return canViewBankAccounts
        default:
          return true
      }
    })
  }, [canViewHospitals, canViewUsers, canViewBankingSetup, canViewBankAccounts])

  return (
    <div className="my-organisation-container">
      <RadioGroup.Buttons
        options={availableTabs}
        defaultValue={activeSubTab}
        onChange={handleTabs}
        className="mt-0 mb-24"
      />
      {activeSubTab === TABS_OPTIONS_KEY.general && <GeneralDetails />}
      {activeSubTab === TABS_OPTIONS_KEY.hospitals &&
        (canViewHospitals || canEditHS) && (
          <HospitalsTable hsName={details?.name} canEditHS={canEditHS} />
        )}
      {activeSubTab === TABS_OPTIONS_KEY.users && (
        <Users outsideCommunityMode={outsideCommunityMode} />
      )}
      {activeSubTab === TABS_OPTIONS_KEY.banking_setup && canViewBankingSetup && (
        <BankingSetupContainer
          communityEntity={{
            entity_id: details?.uuid || '',
            entity_type: 'health_system'
          }}
          businessAccountDetails={businessAccountDetails}
          moovBusinessAccountId={details?.moov_business_account}
          refreshDetails={refreshHSDetails}
        />
      )}
      {activeSubTab === TABS_OPTIONS_KEY.bank_accounts &&
        canViewBankAccounts && (
          <HSDetailsBankAccountsContainer
            businessAccountDetails={businessAccountDetails}
            getBusinessAccountDetails={refreshHSDetails}
          />
        )}
    </div>
  )
}
